/**
 * SQ PDP Kit Reviews — Client-side aggregation from rendered Judge.me widgets.
 *
 * All 7 widgets (kit + 6 children) are rendered in HTML. Judge.me populates
 * data-number-of-reviews and data-average-rating on each .jdgm-rev-widg.
 * This script waits for those attributes, computes the aggregate, and
 * handles tab/dropdown switching.
 */
(function () {
  'use strict';

  var section = document.querySelector('.sq-pdp-kit-reviews');
  if (!section) return;

  var tabs = section.querySelectorAll('.kit-reviews-tab');
  var dropdown = section.querySelector('[data-kit-reviews-dropdown]');
  var dropdownWrapper = section.querySelector('.kit-reviews-dropdown-wrapper');
  var widgetContainer = section.querySelector('[data-kit-reviews-widgets]');
  var panels = widgetContainer.querySelectorAll('.kit-reviews-panel');

  // ── Wait for Judge.me to populate widget data attributes ──
  waitForWidgets(function () {
    computeAggregate();
    updateTabCounts();
    updateDropdownCounts();
  });

  function waitForWidgets(callback, attempts) {
    attempts = attempts || 0;
    var widgets = section.querySelectorAll('.jdgm-rev-widg');

    // Consider ready when at least the kit widget has data, or max attempts reached
    var ready = 0;
    for (var i = 0; i < widgets.length; i++) {
      if (widgets[i].hasAttribute('data-number-of-reviews')) ready++;
    }

    if (ready > 0 || attempts > 50) {
      callback();
      return;
    }

    setTimeout(function () { waitForWidgets(callback, attempts + 1); }, 250);
  }

  // ── Compute aggregate from all rendered widgets ──
  function computeAggregate() {
    var widgets = section.querySelectorAll('.jdgm-rev-widg');
    var totalCount = 0;
    var weightedSum = 0;

    for (var i = 0; i < widgets.length; i++) {
      var count = parseInt(widgets[i].getAttribute('data-number-of-reviews') || '0', 10);
      var rating = parseFloat(widgets[i].getAttribute('data-average-rating') || '0');
      if (count > 0) {
        totalCount += count;
        weightedSum += rating * count;
      }
    }

    var avgRating = totalCount > 0 ? (weightedSum / totalCount) : 0;

    // Update big number
    var bigNumber = section.querySelector('[data-reviews-big-number]');
    if (bigNumber) {
      bigNumber.textContent = avgRating.toFixed(2).replace('.', ',');
    }

    // Update star icons
    var starsContainer = section.querySelector('[data-reviews-stars]');
    if (starsContainer) {
      var fullStars = Math.round(avgRating);
      var svgs = starsContainer.querySelectorAll('svg');
      for (var j = 0; j < svgs.length; j++) {
        if (j < fullStars) {
          svgs[j].classList.remove('star-empty');
        } else {
          svgs[j].classList.add('star-empty');
        }
      }
    }

    // Update count text
    var countEl = section.querySelector('[data-reviews-count]');
    if (countEl) {
      countEl.textContent = totalCount + ' avaliações';
    }

    // Build distribution bars from histogram data across all widgets
    buildDistributionBars(widgets, totalCount);

    // Update buybox badge with aggregate rating + count (persists via observer)
    watchBuyboxBadge(totalCount, avgRating);

    // Show summary (remove loading state)
    var summary = section.querySelector('[data-reviews-summary]');
    if (summary) summary.classList.add('loaded');
  }

  // ── Persist aggregate rating + count on buybox badge via MutationObserver ──
  function watchBuyboxBadge(totalCount, avgRating) {
    var badge = document.querySelector('.jdgm-preview-badge .jdgm-prev-badge');
    var badgeText = document.querySelector('.jdgm-preview-badge .jdgm-prev-badge__text');
    var badgeStars = document.querySelector('.jdgm-preview-badge .jdgm-prev-badge__stars');
    if (!badgeText) return;

    var ratingFormatted = avgRating.toFixed(2).replace('.', ',');
    var expectedHTML = ratingFormatted + ' · <span style="text-decoration:underline">' + totalCount + ' avaliações</span>';
    var expectedPlain = ratingFormatted + ' · ' + totalCount + ' avaliações';
    var expectedScore = avgRating.toFixed(2);

    function applyAggregate() {
      if (badgeText.textContent.trim() !== expectedPlain) {
        badgeText.innerHTML = expectedHTML;
      }
      if (badgeStars && badgeStars.dataset.score !== expectedScore) {
        badgeStars.dataset.score = expectedScore;
      }
      if (badge) {
        if (badge.dataset.averageRating !== expectedScore) badge.dataset.averageRating = expectedScore;
        if (badge.dataset.numberOfReviews !== String(totalCount)) badge.dataset.numberOfReviews = String(totalCount);
      }
    }

    applyAggregate();

    var textObserver = new MutationObserver(applyAggregate);
    textObserver.observe(badgeText, { childList: true, characterData: true, subtree: true });

    if (badgeStars) {
      var starsObserver = new MutationObserver(applyAggregate);
      starsObserver.observe(badgeStars, { attributes: true, attributeFilter: ['data-score'] });
    }
  }

  // ── Aggregate histogram rows from all widgets into distribution bars ──
  function buildDistributionBars(widgets, totalCount) {
    var starCounts = { 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 };

    for (var i = 0; i < widgets.length; i++) {
      var rows = widgets[i].querySelectorAll('[data-rating][data-frequency]');
      if (!rows.length) rows = widgets[i].querySelectorAll('.jdgm-histogram__row');

      for (var j = 0; j < rows.length; j++) {
        var rating = parseInt(rows[j].getAttribute('data-rating') || rows[j].getAttribute('data-score') || '0', 10);
        var frequency = parseInt(rows[j].getAttribute('data-frequency') || rows[j].getAttribute('data-count') || '0', 10);
        if (rating >= 1 && rating <= 5) {
          starCounts[rating] += frequency;
        }
      }
    }

    var barTotal = 0;
    for (var s = 1; s <= 5; s++) barTotal += starCounts[s];

    var container = section.querySelector('[data-reviews-distribution]');
    if (!container || barTotal === 0) return;

    var html = '';
    for (var star = 5; star >= 1; star--) {
      var count = starCounts[star];
      var pct = Math.floor((count / barTotal) * 100);
      html += '<div class="kit-reviews-dist-row">'
        + '<span class="kit-reviews-dist-label">' + star + '</span>'
        + '<span class="kit-reviews-dist-star"><svg viewBox="0 0 20 20"><path d="M10 1l2.39 4.84L17.3 6.8l-3.65 3.56.86 5.02L10 13.12l-4.51 2.26.86-5.02L2.7 6.8l4.91-.96L10 1z" fill="#D4A855"/></svg></span>'
        + '<div class="kit-reviews-dist-bar"><div class="kit-reviews-dist-fill" style="width:' + pct + '%;background:#D4A855"></div></div>'
        + '<span class="kit-reviews-dist-count">' + count + '</span>'
        + '</div>';
    }
    container.innerHTML = html;
  }

  // ── Update tab counts from widget data ──
  function updateTabCounts() {
    // Kit count
    var kitPanel = widgetContainer.querySelector('[data-panel="kit"]');
    var kitWidget = kitPanel ? kitPanel.querySelector('.jdgm-rev-widg') : null;
    var kitCount = kitWidget ? parseInt(kitWidget.getAttribute('data-number-of-reviews') || '0', 10) : 0;

    var kitCountEl = section.querySelector('[data-tab-count-kit]');
    if (kitCountEl) kitCountEl.textContent = '(' + kitCount + ')';

    // Produtos count (sum of all children)
    var childPanels = widgetContainer.querySelectorAll('.kit-reviews-panel:not([data-panel="kit"])');
    var produtosCount = 0;
    for (var i = 0; i < childPanels.length; i++) {
      var w = childPanels[i].querySelector('.jdgm-rev-widg');
      if (w) produtosCount += parseInt(w.getAttribute('data-number-of-reviews') || '0', 10);
    }

    var prodCountEl = section.querySelector('[data-tab-count-produtos]');
    if (prodCountEl) prodCountEl.textContent = '(' + produtosCount + ')';
  }

  // ── Update dropdown option text with review counts ──
  function updateDropdownCounts() {
    if (!dropdown) return;
    var options = dropdown.querySelectorAll('option');
    for (var i = 0; i < options.length; i++) {
      var productId = options[i].value;
      var panel = widgetContainer.querySelector('[data-panel="product-' + productId + '"]');
      var widget = panel ? panel.querySelector('.jdgm-rev-widg') : null;
      var count = widget ? parseInt(widget.getAttribute('data-number-of-reviews') || '0', 10) : 0;
      // Append count to title (title is current text without any existing count)
      var title = options[i].textContent.replace(/\s*\(\d+\)$/, '');
      options[i].textContent = title + ' (' + count + ')';
    }
  }

  // ── Tab switching ──
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      tabs.forEach(function (t) { t.classList.remove('active'); });
      tab.classList.add('active');

      var tabId = tab.dataset.tab;

      if (tabId === 'kit') {
        showPanel('kit');
        if (dropdownWrapper) dropdownWrapper.classList.remove('visible');
      } else if (tabId === 'produtos') {
        if (dropdownWrapper) dropdownWrapper.classList.add('visible');
        if (dropdown && dropdown.value) {
          showPanel('product-' + dropdown.value);
        }
      }
    });
  });

  // ── Dropdown switching ──
  if (dropdown) {
    dropdown.addEventListener('change', function () {
      showPanel('product-' + dropdown.value);
    });
  }

  // ── Show a panel by data-panel value ──
  function showPanel(panelId) {
    for (var i = 0; i < panels.length; i++) {
      panels[i].classList.remove('active');
      panels[i].style.display = 'none';
    }
    var target = widgetContainer.querySelector('[data-panel="' + panelId + '"]');
    if (target) {
      target.style.display = '';
      target.classList.add('active');

      // Re-init Judge.me for newly visible widget (triggers lazy card loading)
      reinitJudgeMe();
    }
  }

  // ── Re-initialize Judge.me for dynamically shown widgets ──
  function reinitJudgeMe() {
    if (typeof jdgm !== 'undefined') {
      if (typeof jdgm.customizeBadges === 'function') jdgm.customizeBadges();
      if (typeof jdgm.loadWidgets === 'function') jdgm.loadWidgets();
    }
  }
})();
